<div
  *ngIf="ready && !visibility.isHidden"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <img
    *ngIf="!isClickable"
    class="imageContent ng-binding"
    [ngClass]="{ firstImage: isFirstPage$ | async }"
    [src]="imgResource"
    [ngStyle]="{ width: width }"
    alt=""
  />
  <a
    *ngIf="isClickable && image.url; else nonUrlImage"
    [href]="image.url"
    target="_blank"
    rel="noopener noreferrer"
    (click)="onClick()"
  >
    <img
      class="imageContent ng-binding"
      [ngClass]="{ firstImage: isFirstPage$ | async }"
      [src]="imgResource"
      [ngStyle]="{ width: width }"
      alt=""
    />
  </a>
  <ng-template #nonUrlImage>
    <button *ngIf="isClickable" type="button" (click)="onClick()">
      <img
        class="imageContent ng-binding"
        [ngClass]="{ firstImage: isFirstPage$ | async }"
        [src]="imgResource"
        [ngStyle]="{ width: width }"
        alt=""
      />
    </button>
  </ng-template>
</div>
